import moment from "jalali-moment";


export function convertToJalali(date: string) {
    if (date) {
      const hejriDate = moment(date, "YYYY-MM-DD")
        .locale("fa")
        .format("YYYY/MM/DD");
      return hejriDate;
    } else {
      return "";
    }
  }
  